export default "__VITE_ASSET__CtyhVJFP__"